interface RadioProps {
  id: string; // Unique ID for the radio button
  name: string; // Radio group name
  value: string; // Value of the radio button
  checked: boolean; // Whether the radio button is checked
  label: string; // Label for the radio button
  onChange: (value: string) => void; // Handler for value change
  className?: string; // Optional additional classes
  disabled?: boolean; // Optional disabled state for the radio button
  ariaDescribedBy?: string; // Optional id of the element describing this radio
}

const Radio: React.FC<RadioProps> = ({
  id,
  name,
  value,
  checked,
  label,
  onChange,
  className = "",
  disabled = false,
  ariaDescribedBy,
}) => {
  return (
    <label
      htmlFor={id}
      className={`relative flex cursor-pointer select-none items-center gap-3 text-sm font-medium ${
        disabled
          ? "opacity-50 cursor-not-allowed"
          : ""
      } ${className}`}
    >
      <input
        id={id}
        name={name}
        type="radio"
        value={value}
        checked={checked}
        onChange={() => !disabled && onChange(value)} // Prevent onChange when disabled
        className="peer sr-only"
        disabled={disabled} // Disable input
        aria-describedby={ariaDescribedBy}
      />
      <span
        className={`flex h-5 w-5 items-center justify-center rounded-full border peer-focus-visible:ring-3 peer-focus-visible:ring-mp-primary/40 ${
          disabled
            ? "bg-mp-background border-mp-input"
            : checked
              ? "border-mp-primary bg-mp-primary"
              : "bg-mp-surface border-mp-input"
        }`}
      >
        <span
          className={`h-2 w-2 rounded-full bg-mp-surface ${
            checked ? "block" : "hidden"
          }`}
        ></span>
      </span>
      {label}
    </label>
  );
};

export default Radio;
